// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"dc825c0a","453":"205248ac","629":"f55d6da3","640":"d1248b3e"}[chunkId] + ".chunk.js";
};